import { useCallback, useEffect, useState } from 'react';
import mensajeriaInternaService from '../services/MensajeriaInternaService';
import particularesApiService from '../services/ParticularesApiService';

const POLL_MS = 5 * 60 * 1000;
export const MENSAJES_NO_LEIDOS_REFRESH_EVENT = 'mensajes-internos:refresh';

const parseCount = (response) => {
  const value = response?.totalNoLeidos ?? response?.TotalNoLeidos ?? response?.total ?? response?.Total ?? 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

const normalizeScope = (options) => {
  if (typeof options === 'string') return options;
  return options?.scope || 'colegio';
};

const useMensajesNoLeidos = (enabled = true, options = {}) => {
  const [count, setCount] = useState(0);
  const scope = normalizeScope(options);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      return 0;
    }

    try {
      const response = scope === 'particular'
        ? await particularesApiService.getMensajesNoLeidosCount()
        : await mensajeriaInternaService.getNoLeidosCount();
      const nextCount = parseCount(response);
      setCount(nextCount);
      return nextCount;
    } catch (error) {
      setCount(0);
      return 0;
    }
  }, [enabled, scope]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    refresh();
    const intervalId = window.setInterval(refresh, POLL_MS);
    window.addEventListener(MENSAJES_NO_LEIDOS_REFRESH_EVENT, refresh);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener(MENSAJES_NO_LEIDOS_REFRESH_EVENT, refresh);
    };
  }, [enabled, refresh]);

  return { count, refresh };
};

export default useMensajesNoLeidos;
